import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/security-audit/registry",
    name: "registry-audit",
    component: () => import("../views/security-audit/RegistryAuditView.vue"),
    beforeEnter: (to, from, next) => (localStorage.ad_to_ac_se ? next() : next("/login")),
  },
  {
    path: "/admin-devices",
    name: "admin-devices",
    component: () => import("../views/AdminDevicesView.vue"),
    beforeEnter: (to, from, next) => (localStorage.ad_to_ac_se ? next() : next("/login")),
  },
  {
    path: "/security-audit/investigate",
    name: "security-audit-investigate",
    component: () =>
      import(/* webpackChunkName: "security-audit-investigate" */ "../views/security-audit/InvestigatorView.vue"),
    beforeEnter: (to, from, next) => {
      // Login presence only; the API authorizes the exact active investigator.
      if (localStorage.ad_to_ac_se) next();
      else next("/login");
    },
  },
  {
    // NZSC-3417: 로그인 직후 첫 화면을 리포트 목록으로. 종전에는 캠페인 서울 화면이었다.
    //   목록 화면은 page·pageSize 쿼리를 요구하므로(없으면 목록 API 400) 컴포넌트를 직접
    //   물리지 않고 사이드바 '리포트' 와 같은 주소로 보낸다.
    //   redirect 는 beforeEnter 를 타지 않는다. 인증 검사는 목적지(/order-confirm)의
    //   beforeEnter 가 그대로 수행하므로 로그인 없이 들어와도 /login 으로 간다.
    //   KRE-17: 쿼리를 문자열에 붙이면 vue-router 3.6 이 경로째로 매칭해(일치 0건) 첫 접속이 흰 화면이었다.
    //   경로·쿼리를 나눠 넘긴다.
    path: "/",
    name: "home",
    redirect: { path: "/order-confirm", query: { page: "1", pageSize: "30", active: "report-depth01" } },
  },
  {
    path: "/login",
    name: "login",
    component: () => import(/* webpackChunkName: "about" */ "../views/LoginView.vue"),
  },
  {
    path: "/change",
    name: "change",
    component: () => import(/* webpackChunkName: "about" */ "../views/ChangeView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },

  //---------------------
  // 회원
  //--------------------- \
  {
    path: "/user/info",
    name: "user-info",
    component: () => import(/* webpackChunkName: "about" */ "../views/user/InfoView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/user/withdrawal",
    name: "user-withdrawal",
    component: () => import(/* webpackChunkName: "about" */ "../views/WithdrawalView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/user/withdrawal/:recordKey",
    name: "user-withdrawal-detail",
    component: () => import(/* webpackChunkName: "about" */ "../views/WithdrawalDetailView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) next();
      else next("/login");
    },
  },

  //---------------------
  // 직거래
  //---------------------
  {
    path: "/user/direct-deal",
    name: "user-direct-deal",
    component: () => import(/* webpackChunkName: "about" */ "../views/direct-deal/ListView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/user/direct-deal/detail/:seq",
    name: "user-direct-deal-detail",
    component: () => import(/* webpackChunkName: "about" */ "../views/direct-deal/DetailView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },

  //---------------------
  // 리포트
  //---------------------
  {
    path: "/order-save/detail/:user_no/:order_seq/:cart_seq",
    name: "change",
    component: () => import(/* webpackChunkName: "about" */ "../views/report-data/SaveView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/report/preview/:report_seq/:order_seq",
    name: "report-preview",
    component: () => import(/* webpackChunkName: "about" */ "../views/report-data/PreviewView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/order-confirm",
    name: "order-confirm",
    component: () => import(/* webpackChunkName: "about" */ "../views/report-data/ListView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/order-confirm/detail/:user_no/:order_seq",
    name: "order-confirmDetail",
    component: () => import(/* webpackChunkName: "about" */ "../views/report-data/DetailView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/report/individual-credit",
    name: "report/individual-credit",
    component: () => import(/* webpackChunkName: "about" */ "../views/credit/IndivCreditListView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/report/undetermined",
    name: "report/undetermined",
    component: () => import(/* webpackChunkName: "about" */ "../views/report-data/UndeterminedListView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    // NZSC-3016 — 발급 예정 시간 오버라이드 (report_issue_time) 관리
    path: "/report/issue-time",
    name: "report-issue-time",
    component: () => import(/* webpackChunkName: "about" */ "../views/report-issue-time/ListView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    // NZSC-3250 — AI 프롬프트 관리 (CS/계약상담/리포트 질문답변)
    path: "/prompt-admin",
    name: "prompt-admin",
    component: () => import(/* webpackChunkName: "prompt-admin" */ "../views/prompt-admin/PromptAdminView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    // NZSC-3221 — 궁금한점 답변 전수검수 (큐)
    path: "/report/qna",
    name: "report-qna",
    component: () => import(/* webpackChunkName: "report-qna" */ "../views/report-qna/ListView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    // NZSC-3221 — 궁금한점 답변 검수 화면
    path: "/report/qna/:qna_seq",
    name: "report-qna-detail",
    component: () => import(/* webpackChunkName: "report-qna" */ "../views/report-qna/DetailView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },

  //---------------------
  // 구독
  //---------------------
  {
    path: "/subscribe",
    name: "subscribe",
    component: () => import(/* webpackChunkName: "about" */ "../views/subscribe/ListView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/subscribe/basic",
    name: "subscribe",
    component: () => import(/* webpackChunkName: "about" */ "../views/subscribe/ListViewTemp.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/subscribe/detail",
    name: "subscribe",
    component: () => import(/* webpackChunkName: "about" */ "../views/subscribe/DetailView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/subscribe-basic/detail/:user_no/:subscribe_cart_seq",
    name: "subscribe-basic",
    component: () => import(/* webpackChunkName: "about" */ "../views/subscribe/DetailViewTemp.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/subscribe/reorder",
    name: "subscribe-reorder",
    component: () => import(/* webpackChunkName: "about" */ "../views/subscribe/ReOrderView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/subscribe/alarm",
    name: "subscribe-alarm",
    component: () => import(/* webpackChunkName: "about" */ "../views/subscribe/AlarmView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/subscribe/preview/:id",
    name: "subscribe-preview",
    component: () => import(/* webpackChunkName: "about" */ "../views/subscribe/preview/SubscribeWatchingView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/report/loan/detail",
    name: "report-loan-detail",
    component: () => import("../components/report/LoanDetailView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },

  {
    path: "/subscribe/unapproved",
    name: "subscribe-unapproved",
    component: () => import(/* webpackChunkName: "about" */ "../views/subscribe/ListUnapprovedView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/subscribe/change",
    name: "change-issue",
    component: () => import(/* webpackChunkName: "about" */ "../views/subscribe/change/ListChangeIssueView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/subscribe/change-register",
    name: "change-issue-register",
    component: () => import(/* webpackChunkName: "about" */ "../views/subscribe/change/ListChangeRegisterView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/subscribe/change-complete",
    name: "change-issue-complete",
    component: () => import(/* webpackChunkName: "about" */ "../views/subscribe/change/ListChangeRegisterView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    // NZSC-4296 — 매매 프리미엄 새 엔진 등기부 나란히 비교(구독 상세 '운영 확인' 영역에서 연다. 사이드바 메뉴 아님).
    path: "/subscribe/premium-compare",
    name: "premium-compare",
    component: () => import(/* webpackChunkName: "about" */ "../views/subscribe/PremiumCompareView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/subscribe/premium-monitoring",
    name: "premium-monitoring",
    component: () => import(/* webpackChunkName: "about" */ "../views/subscribe/PremiumMonitoringView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    // NZSC-2995: cow 무한발급 의심 케이스 어드민 페이지 (모닝 브리핑 SSOT 이전)
    path: "/subscribe/cow-infinite-suspect",
    name: "cow-infinite-suspect",
    component: () => import(/* webpackChunkName: "about" */ "../views/subscribe/CowInfiniteSuspectView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: `/subscribe/history`,
    name: "subscribe-history",
    component: () => import(/* webpackChunkName: "about" */ "../components/subscribe/History.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },

  //---------------------
  // COLD
  //---------------------
  {
    path: "/cold/restart",
    name: "cold-restart",
    component: () => import("../views/cold/DetailView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/cold/building-and-price",
    name: "cold-building-and-price",
    component: () => import("../views/cold/DetailView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    // NZSC-3199 — 외부 API 점검창 관리 (external_api_maintenance). provider='cold' 점검 시 콜드 분석 차단
    path: "/external-api-maintenance",
    name: "external-api-maintenance",
    component: () => import(/* webpackChunkName: "about" */ "../views/external-api-maintenance/ListView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/estate/document",
    name: "estate-document",
    component: () => import(/* webpackChunkName: "about" */ "../views/EstateDocumentView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },

  //---------------------
  // 등기부 일괄발급 (Registry Batch)
  //---------------------
  {
    path: "/registry-batch/upload",
    name: "registry-batch-upload",
    component: () =>
      import(/* webpackChunkName: "registry-batch" */ "../views/registry-batch/RegistryBatchUploadView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    // NZSC-2697 — 지도(폴리곤) 기반 일괄발급 entry (beaver 연동)
    path: "/registry-batch/polygon",
    name: "registry-batch-polygon",
    component: () =>
      import(/* webpackChunkName: "registry-batch" */ "../views/registry-batch/RegistryBatchPolygonView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/registry-batch/list",
    name: "registry-batch-list",
    component: () =>
      import(/* webpackChunkName: "registry-batch" */ "../views/registry-batch/RegistryBatchListView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/registry-batch/:batchId",
    name: "registry-batch-detail",
    component: () =>
      import(/* webpackChunkName: "registry-batch" */ "../views/registry-batch/RegistryBatchDetailView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },

  //---------------------
  // 결제
  //---------------------
  {
    path: "/order/cancel",
    name: "order-cancel",
    component: () => import("../views/order/cancel/ListView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/order/refund",
    name: "order-refund",
    component: () => import("../views/order/refund/ListRefundView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/order/coupon",
    name: "order-coupon",
    component: () => import("../views/order/coupon/ListView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/manual-payment",
    name: "manual-payment",
    component: () => import("../views/manual-payment/ManualPaymentView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) next();
      else next("/");
    },
  },
  {
    path: "/manual-payment/history",
    name: "manual-payment-history",
    component: () => import("../views/manual-payment/ManualPaymentHistoryView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) next();
      else next("/");
    },
  },

  //---------------------
  // sci
  //---------------------
  {
    path: "/credit/sci",
    name: "credit-sci",
    component: () => import(/* webpackChunkName: "about" */ "../views/sci/DetailView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },

  //---------------------
  // gom
  //---------------------
  {
    path: "/gom/user",
    name: "gom-user",
    component: () => import(/* webpackChunkName: "about" */ "../views/gom/user/UserView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/gom/order",
    name: "gom-order",
    component: () => import(/* webpackChunkName: "about" */ "../views/gom/order/OrderView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/gom/report",
    name: "gom-report",
    component: () => import(/* webpackChunkName: "about" */ "../views/gom/report/ReportView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/gom/subscribe",
    name: "gom-subscribe",
    component: () => import(/* webpackChunkName: "about" */ "../views/gom/subscribe/SubscribeView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },

  //---------------------
  // doby
  //---------------------
  {
    path: "/doby/review-list",
    name: "doby-review-list",
    component: () => import(/* webpackChunkName: "about" */ "../views/doby/StatusListView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/doby/reject-list",
    name: "doby-reject-list",
    component: () => import(/* webpackChunkName: "about" */ "../views/doby/StatusListView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/doby/confirm-list",
    name: "doby-confirm-list",
    component: () => import(/* webpackChunkName: "about" */ "../views/doby/ConfirmListView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/doby/transfer-list",
    name: "doby-transfer-list",
    component: () => import(/* webpackChunkName: "about" */ "../views/doby/TransferListView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/doby/detail/:user_no/:doby_seq",
    name: "doby-detail",
    component: () => import(/* webpackChunkName: "about" */ "../views/doby/DetailView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/doby/utils",
    name: "doby-utils",
    component: () => import(/* webpackChunkName: "about" */ "../views/doby/UtilsView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },

  //---------------------
  // insurance
  //---------------------
  {
    path: "/insurance/lotte-legal-001/review-list",
    name: "insurance-lotte-legal-001-review-list",
    component: () => import(/* webpackChunkName: "about" */ "../views/insurance/lotte_legal_001/StatusListView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/insurance/lotte-legal-001/confirm-list",
    name: "insurance-lotte-legal-001-confirm-list",
    component: () => import(/* webpackChunkName: "about" */ "../views/insurance/lotte_legal_001/StatusListView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/insurance/lotte-legal-001/reject-list",
    name: "insurance-lotte-legal-001-reject-list",
    component: () => import(/* webpackChunkName: "about" */ "../views/insurance/lotte_legal_001/StatusListView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/insurance/lotte-legal-001/cancel-list",
    name: "insurance-lotte-legal-001-cancel-list",
    component: () => import(/* webpackChunkName: "about" */ "../views/insurance/lotte_legal_001/StatusListView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/insurance/lotte-legal-001/free-month-list",
    name: "insurance-lotte-legal-001-free-month-list",
    component: () => import(/* webpackChunkName: "about" */ "../views/insurance/lotte_legal_001/StatusListView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },

  //---------------------
  // insurance - 퍼스트아메리칸(FA) 권원보험 검수 (NZSC-3189)
  //---------------------
  {
    path: "/insurance/firstam/review",
    name: "insurance-firstam-review",
    component: () => import(/* webpackChunkName: "about" */ "../views/insurance/firstam/ReviewListView.vue"),
    props: { reviewVersion: "v1" },
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/insurance/firstam/review-v2",
    name: "insurance-firstam-review-v2",
    component: () => import(/* webpackChunkName: "about" */ "../views/insurance/firstam/ReviewListView.vue"),
    props: { reviewVersion: "v2" },
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/insurance/firstam/logs",
    name: "insurance-firstam-logs",
    component: () => import(/* webpackChunkName: "about" */ "../views/insurance/firstam/ApiLogListView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/insurance/firstam/review/:seq",
    name: "insurance-firstam-review-detail",
    component: () => import(/* webpackChunkName: "about" */ "../views/insurance/firstam/ReviewDetailView.vue"),
    props: { reviewVersion: "v1" },
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/insurance/firstam/review-v2/:seq",
    name: "insurance-firstam-review-v2-detail",
    component: () => import(/* webpackChunkName: "about" */ "../views/insurance/firstam/ReviewDetailView.vue"),
    props: { reviewVersion: "v2" },
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },

  //---------------------
  // analyze
  //---------------------
  {
    path: "/insurance/analyze",
    name: "insurance-analyze",
    component: () => import(/* webpackChunkName: "about" */ "../views/insurance/InsuranceAnalyzeView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },

  //---------------------
  // 태풍
  //---------------------
  {
    path: "/typhoon/lotteglogis/list",
    name: "typhoon-lotteglogis-list",
    component: () => import(/* webpackChunkName: "about" */ "../views/typhoon/lotteglogis/ListView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/typhoon/lotteglogis/detail/:request_seq",
    name: "typhoon-lotteglogis-detail",
    component: () => import(/* webpackChunkName: "about" */ "../views/typhoon/lotteglogis/DetailView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },

  //---------------------
  // 캠페인
  //---------------------

  //---------------------
  // 비버 모니터링 (NZSC-2982)
  //---------------------
  {
    path: "/beaver/monitor",
    name: "beaver-monitor",
    component: () => import(/* webpackChunkName: "beaver" */ "../views/beaver/MonitorView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/alfred/monitor",
    name: "alfred-monitor",
    component: () => import(/* webpackChunkName: "alfred" */ "../views/alfred/AlfredMonitorView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/alfred/test",
    name: "alfred-test",
    component: () => import(/* webpackChunkName: "alfred" */ "../views/alfred/AlfredTestConsoleView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/alfred/daily",
    name: "alfred-daily",
    component: () => import(/* webpackChunkName: "alfred" */ "../views/alfred/AlfredDailyReportView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.ad_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
